import chroma from 'chroma-js';
import color from 'color';
export const DARK_GREENISH_BLUE = '#2a3f50'; //'#254753'
export const DARK_GREENISH_BLUE_NUM = color(DARK_GREENISH_BLUE).rgbNumber();
export const DARKEST_GREENISH_BLUE = '#1c2b35'; //'#05131b'
export const DARKEST_GREENISH_BLUE_NUM = color(DARKEST_GREENISH_BLUE).rgbNumber();
export const BLUE_COLOR = '#457c9d';
export const GREEN_COLOR = '#05bb41';
export const LIGHT_GREEN_COLOR = color(GREEN_COLOR).lighten(0.3).hex();
export const DARK_GREEN_COLOR = color(GREEN_COLOR).darken(0.3).hex();
export const PURPLE_COLOR = '#3f2452';
const LIGHT_PURPLE_COLOR = color(PURPLE_COLOR).rotate(-40).lightness(65).hex();
export const YELLOW_COLOR = '#f4a361';
export const LIGHT_YELLOW_COLOR = '#f4e0a4';
export const MEDIUM_LIGHT_YELLOW_COLOR = color(YELLOW_COLOR).mix(color(LIGHT_YELLOW_COLOR), 0.25).hex();
export const RED_COLOR = '#d1301a';
export const DARK_RED_COLOR = color(RED_COLOR).darken(0.3).hex();
export const LIGHT_RED_COLOR = color(RED_COLOR).lighten(0.3).hex();
export const TURQUOISE_COLOR = '#2b9d8f';
const SLIGHT_GREENISH_GRAY_COLOR = color('#adb5bd').rotate(-20).lightness(50).hex();
export const LIGHT_BLUE_COLOR = color(BLUE_COLOR).lighten(0.5).saturate(0.7).hex();
export const RED_BUTTON_COLOR = '#A43038';
export const PLAYER_INFO_STAT_VALUE_COLOR = color(BLUE_COLOR).darken(0.2).hex();
export const CARD_SUIT_BLACK_COLOR = '#363647';
export const CARD_SUIT_RED_COLOR = '#a33038';
export const CARD_SUIT_GREEN_COLOR = '#025c21'; // for 4-color deck
export const CARD_SUIT_BLUE_COLOR = '#115cb2'; // for 4-color deck
export const CARD_SUIT_BLACK_COLOR_NUM = color(CARD_SUIT_BLACK_COLOR).rgbNumber();
export const CARD_SUIT_RED_COLOR_NUM = color(CARD_SUIT_RED_COLOR).rgbNumber();
export const CARD_SUIT_GREEN_COLOR_NUM = color(CARD_SUIT_GREEN_COLOR).rgbNumber();
export const CARD_SUIT_BLUE_COLOR_NUM = color(CARD_SUIT_BLUE_COLOR).rgbNumber();
export const BUTTON_SUB_LABEL_COLOR = color(BLUE_COLOR).darken(0.35).saturate(0.7).hex();
export const BUTTON_SUB_LABEL_COLOR_NUM = color(BUTTON_SUB_LABEL_COLOR).rgbNumber();
export const GAME_BUTTON_BORDER_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).darken(0.4).hex();
export const GAME_BUTTON_BACKGROUND_DISABLED_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).darken(0.1).hex();
export const GAME_BUTTON_BACKGROUND_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).lighten(0.25).hex();
export const BUTTON_BACKGROUND_COLOR_NUM = color(GAME_BUTTON_BACKGROUND_COLOR).rgbNumber();
export const GAME_BUTTON_BACKGROUND_HOVER_COLOR = color(BUTTON_BACKGROUND_COLOR_NUM).lighten(0.35).hex();
export const BUTTON_BACKGROUND_HOVER_COLOR_NUM = color(GAME_BUTTON_BACKGROUND_HOVER_COLOR).rgbNumber();
export const BET_SLIDER_TRACK_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).darken(0.7).hex();
export const BET_STEP_DISABLED_BUTTON_ICON_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).darken(0.5).hex();
export const SET_BET_BUTTON_BACKGROUND_COLOR_NUM = color(SLIGHT_GREENISH_GRAY_COLOR).darken(0.1).rgbNumber();
export const SET_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM = color(SLIGHT_GREENISH_GRAY_COLOR).rgbNumber();
export const BET_CONTROLS_BACKGROUND_COLOR = color(BUTTON_BACKGROUND_COLOR_NUM).darken(0.5).hex();
export const BET_CONTROLS_BACKGROUND_COLOR_NUM = color(BET_CONTROLS_BACKGROUND_COLOR).rgbNumber();
export const BET_CONTROLS_BACKGROUND_BORDER_COLOR_NUM = color(BUTTON_BACKGROUND_COLOR_NUM).darken(0.7).rgbNumber();
export const BET_CONTROLS_BACKGROUND_HIGHLIGHT_COLOR_NUM = color(BUTTON_BACKGROUND_COLOR_NUM).darken(0.4).rgbNumber();
export const AUTO_BET_BUTTON_BACKGROUND_COLOR = color(BET_CONTROLS_BACKGROUND_BORDER_COLOR_NUM).darken(0.1).hex();
export const AUTO_BET_BUTTON_BACKGROUND_COLOR_NUM = color(AUTO_BET_BUTTON_BACKGROUND_COLOR).rgbNumber();
export const AUTO_BET_BUTTON_BACKGROUND_HOVER_COLOR = color(BET_CONTROLS_BACKGROUND_BORDER_COLOR_NUM).lighten(0.1).hex();
export const AUTO_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM = color(AUTO_BET_BUTTON_BACKGROUND_HOVER_COLOR).rgbNumber();
export const ALERT_BUTTON_BACKGROUND_COLOR = color(RED_COLOR).darken(0.5).hex();
export const ALERT_BUTTON_BACKGROUND_COLOR_NUM = color(ALERT_BUTTON_BACKGROUND_COLOR).rgbNumber();
export const ALERT_BUTTON_BACKGROUND_HOVER_COLOR = color(ALERT_BUTTON_BACKGROUND_COLOR_NUM).lighten(0.35).hex();
export const ALERT_BUTTON_BACKGROUND_HOVER_COLOR_NUM = color(ALERT_BUTTON_BACKGROUND_HOVER_COLOR).rgbNumber();
export const ALERT_BUTTON_TEXT_COLOR = color(RED_COLOR).lighten(0.5).hex();
export const ALERT_BUTTON_TEXT_COLOR_NUM = color(ALERT_BUTTON_TEXT_COLOR).rgbNumber();
export const PLAYER_ALL_BUBBLES_OUTLINE_COLOR_NUM = BUTTON_BACKGROUND_COLOR_NUM;
export const ALL_IN_PLAYER_STATUS_COLOR_NUM = color(YELLOW_COLOR).rgbNumber();
export const ALL_IN_PLAYER_STATUS_STROKE_COLOR_NUM = color(RED_COLOR).darken(0.25).rgbNumber();
export const CHIP_LEADER_PLAYER_STATUS_COLOR_NUM = color(GREEN_COLOR).lighten(0.2).rgbNumber();
export const LOBBY_ROOMS_PANEL_BACKGROUND_COLOR = color(DARK_GREENISH_BLUE
// was '#254653'
)
    .darken(0.35)
    .string();
export const MTT_STAGING_MAIN_PANEL_BACKGROUND_COLOR = LOBBY_ROOMS_PANEL_BACKGROUND_COLOR;
export const MTT_STAGING_MAIN_PANEL_HOVER_COLOR = color(MTT_STAGING_MAIN_PANEL_BACKGROUND_COLOR)
    .mix(color('white'), 0.05)
    .string();
export const MTT_STAGING_PLAYER_DIVIDER_COLOR = color(MTT_STAGING_MAIN_PANEL_HOVER_COLOR)
    .mix(color('black'), 0.2)
    .string();
export const ACTIVE_TIMER_GREEN_COLOR_NUM = color(GREEN_COLOR).rgbNumber();
export const ACTIVE_TIMER_YELLOW_COLOR_NUM = color(YELLOW_COLOR).rgbNumber();
export const ACTIVE_TIMER_RED_COLOR_NUM = color(RED_COLOR).rgbNumber();
export const ACTIVE_TIMER_GREEN_HIGHLIGHT_COLOR_NUM = color(ACTIVE_TIMER_GREEN_COLOR_NUM)
    .mix(color('white'), 0.25)
    .rgbNumber();
export const ACTIVE_TIMER_YELLOW_HIGHLIGHT_COLOR_NUM = color(ACTIVE_TIMER_YELLOW_COLOR_NUM)
    .mix(color('white'), 0.25)
    .rgbNumber();
export const ACTIVE_TIMER_RED_HIGHLIGHT_COLOR_NUM = color(ACTIVE_TIMER_RED_COLOR_NUM)
    .mix(color('white'), 0.15)
    .rgbNumber();
export const ALL_IN_GAME_DARK_RED_COLOR = '#660000';
export const ALL_IN_GAME_LIGHT_RED_COLOR = color(ALL_IN_GAME_DARK_RED_COLOR).mix(color(YELLOW_COLOR), 0.75).hex();
export const RED_BUTTON_ACCENT_COLOR_NUM = color(RED_COLOR).darken(0.3).rgbNumber();
export const GREEN_BUTTON_ACCENT_COLOR_NUM = color(GREEN_COLOR).darken(0.3).rgbNumber();
export const BLUE_BUTTON_ACCENT_COLOR_NUM = color(BLUE_COLOR).darken(0.2).rgbNumber();
export const RED_BUTTON_ACCENT_COLOR = color(RED_BUTTON_ACCENT_COLOR_NUM).hex();
export const GREEN_BUTTON_ACCENT_COLOR = color(GREEN_BUTTON_ACCENT_COLOR_NUM).hex();
export const BLUE_BUTTON_ACCENT_COLOR = color(BLUE_BUTTON_ACCENT_COLOR_NUM).hex();
export const WIN_GREEN_COLOR_NUM = ACTIVE_TIMER_GREEN_HIGHLIGHT_COLOR_NUM;
export const WIN_CHIPS_ANIM_COLOR_NUM = color(WIN_GREEN_COLOR_NUM).lighten(0.5).rgbNumber();
export const DEFAULT_BACKGROUND_COLOR = DARK_GREENISH_BLUE;
export const DEFAULT_BACKGROUND_HOVER_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.25).string();
export const DEFAULT_BACKGROUND_DIVIDER_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.15).string();
export const SUB_PAGE_HEADER_BACKGROUND_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.2).string();
export const SUB_PAGE_FOOTER_BACKGROUND_COLOR = color(DEFAULT_BACKGROUND_COLOR).darken(0.2).string();
export const DEFAULT_DARKER_BACKGROUND_COLOR = color(DEFAULT_BACKGROUND_COLOR).darken(0.15).hex();
export const DEFAULT_DARKER_BACKGROUND_TEXT_COLOR = color(DEFAULT_BACKGROUND_COLOR).mix(color('white'), 0.85).hex();
export const DEFAULT_DARKER_BACKGROUND_COLOR2 = color(DEFAULT_DARKER_BACKGROUND_COLOR).darken(0.1).hex();
export const DEFAULT_DARKER_BACKGROUND_COLOR3 = color(DEFAULT_DARKER_BACKGROUND_COLOR2).darken(0.1).hex();
export const ENTRY_SIDE_PANEL_BORDER_COLOR = color(DEFAULT_DARKER_BACKGROUND_COLOR).mix(color('black'), 0.4).hex();
export const ENTRY_SIDE_PANEL_DIVIDER_COLOR = ENTRY_SIDE_PANEL_BORDER_COLOR;
export const FEATURE_SHOWCASE_BACKGROUND_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.25).string();
export const DEFAULT_LINK_COLOR = YELLOW_COLOR;
export const POKER_STAGE_DEFAULT_BACKGROUND_COLOR_NUM = color(DEFAULT_DARKER_BACKGROUND_COLOR).rgbNumber();
export const DRAWER_BACKGROUND_COLOR = DEFAULT_BACKGROUND_COLOR;
export const DRAWER_EXPANDABLE_SECTION_HEADER_COLOR = color(DRAWER_BACKGROUND_COLOR).lighten(0.4).hex();
export const DRAWER_EXPANDABLE_SECTION_SHADOW_COLOR = color(DRAWER_BACKGROUND_COLOR).darken(0.1).hex();
export const DRAWER_EXPANDABLE_SECTION_CONTENT_COLOR = color(DRAWER_BACKGROUND_COLOR).lighten(0.2).hex();
export const DRAWER_BUTTON_HOVER_COLOR = color(DRAWER_EXPANDABLE_SECTION_HEADER_COLOR).lighten(0.2).hex();
export const BET_POT_TEXT_STROKE_COLOR_NUM = color(0x444444).rgbNumber();
export const CHAT_PANEL_BACKGROUND_COLOR = BLUE_COLOR;
export const CHAT_PANEL_BORDER_COLOR = '#1c3557';
export const CHAT_PANEL_MESSAGES_BACKGROUND_COLOR = color(CHAT_PANEL_BACKGROUND_COLOR)
    .mix(color('white'), 0.65)
    .string();
export const CHAT_PANEL_MESSAGES_SUBTLE_BACKGROUND_COLOR = color(CHAT_PANEL_MESSAGES_BACKGROUND_COLOR)
    .darken(0.1)
    .string();
export const CHAT_PANEL_MESSAGES_HAND_REVEAL_BACKGROUND_COLOR = color(CHAT_PANEL_MESSAGES_BACKGROUND_COLOR)
    .lighten(0.1)
    .string();
export const FRIENDS_PANEL_BACKGROUND_COLOR = color(TURQUOISE_COLOR).darken(0.15).string();
export const FRIENDS_PANEL_CONTENT_COLOR = TURQUOISE_COLOR;
export const FRIENDS_PANEL_SECTION_HEADER_COLOR = color(FRIENDS_PANEL_CONTENT_COLOR).mix(color('white'), 0.3).string();
export const FRIENDS_PANEL_SECTION_CONTENT_COLOR = color(FRIENDS_PANEL_CONTENT_COLOR).mix(color('white'), 0.15).string();
export const FRIENDS_PANEL_SECTION_SHADOW_COLOR = color(FRIENDS_PANEL_CONTENT_COLOR).darken(0.1).string();
export const FRIENDS_PANEL_LIST_ITEM_HOVER_COLOR = color(FRIENDS_PANEL_SECTION_CONTENT_COLOR)
    .mix(color('white'), 0.07)
    .string();
export const FRIENDS_PANEL_BORDER_COLOR = FRIENDS_PANEL_BACKGROUND_COLOR; //'#67c8bf'
export const FRIENDS_PANEL_DIVIDER_COLOR = FRIENDS_PANEL_SECTION_HEADER_COLOR;
export const ROOM_INFO_PANEL_BACKGROUND_COLOR = '#eac56a';
export const ROOM_INFO_PANEL_BORDER_COLOR = '#f4e0a4';
export const ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR = color(ROOM_INFO_PANEL_BACKGROUND_COLOR)
    .mix(color('white'))
    .string();
export const ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR = color(ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'))
    .string();
export const ROOM_INFO_PANEL_LIST_ITEM_DIVIDER_COLOR = ROOM_INFO_PANEL_BACKGROUND_COLOR;
export const ROOM_INFO_PANEL_SECTION_BACKGROUND_COLOR = ROOM_INFO_PANEL_LIST_ITEM_DIVIDER_COLOR;
export const ROOM_INFO_PANEL_SECTION_SUBTLE_BACKGROUND_COLOR = color(ROOM_INFO_PANEL_SECTION_BACKGROUND_COLOR)
    .mix(color(ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR))
    .hex();
export const ROOM_INFO_PANEL_HEADER_COLOR = color(ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR).mix(color('white')).string();
export const SELF_PANEL_BACKGROUND_COLOR = SLIGHT_GREENISH_GRAY_COLOR;
export const SELF_PANEL_BORDER_COLOR = color(SELF_PANEL_BACKGROUND_COLOR).mix(color('black'), 0.65).string();
export const SELF_PANEL_CONTENT_BACKGROUND_COLOR = color(SELF_PANEL_BACKGROUND_COLOR).mix(color('white'), 0.25).string();
export const SELF_PANEL_CONTENT_HOVER_COLOR = color(SELF_PANEL_CONTENT_BACKGROUND_COLOR)
    .mix(color('white'), 0.25)
    .string();
export const SELF_PANEL_BUTTON_BACKGROUND_COLOR = color(SELF_PANEL_CONTENT_BACKGROUND_COLOR)
    .mix(color('white'), 0.2)
    .hex();
export const SELF_PANEL_BUTTON_HOVER_COLOR = color(SELF_PANEL_CONTENT_BACKGROUND_COLOR).mix(color('white'), 0.4).hex();
export const SELF_PANEL_BUTTON_ACTIVE_COLOR = color(SELF_PANEL_BUTTON_HOVER_COLOR).mix(color('white'), 0.4).hex();
export const PLAYER_INFO_PANEL_BACKGROUND_COLOR = SELF_PANEL_BACKGROUND_COLOR;
export const PLAYER_INFO_PANEL_LIST_BACKGROUND_COLOR = SELF_PANEL_CONTENT_BACKGROUND_COLOR;
export const PLAYER_INFO_PANEL_LIST_ALTERNATE_ROW_COLOR = color(PLAYER_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('black'), 0.05)
    .string();
export const PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR = SELF_PANEL_CONTENT_HOVER_COLOR;
export const PLAYER_INFO_PANEL_BORDER_COLOR = SELF_PANEL_BORDER_COLOR;
export const PLAYER_INFO_PANEL_HEADER_COLOR = color('#2A9D8F').mix(color('white')).string();
export const PLAYER_INFO_PANEL_SECTION_HEADER_COLOR = PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR;
export const PLAYER_INFO_PANEL_SECTION_BUTTON_COLOR = PLAYER_INFO_PANEL_SECTION_HEADER_COLOR;
export const PLAYER_INFO_PANEL_SECTION_CONTENT_COLOR = color(PLAYER_INFO_PANEL_SECTION_HEADER_COLOR)
    .mix(color(SELF_PANEL_CONTENT_BACKGROUND_COLOR))
    .hex();
export const PLAYER_INFO_PANEL_SECTION_SHADOW_COLOR = color(PLAYER_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .darken(0.3)
    .string();
export const ADMIN_PANEL_HEADER_BACKGROUND_COLOR = RED_BUTTON_COLOR;
export const ADMIN_PANEL_BORDER_COLOR = '#000000';
export const ADMIN_PANEL_CONTENT_BACKGROUND_COLOR = color(ADMIN_PANEL_HEADER_BACKGROUND_COLOR).darken(0.6).hex();
export const TOURNEY_HEADER_BACKGROUND_COLOR = ADMIN_PANEL_CONTENT_BACKGROUND_COLOR;
export const PRIVATE_MESSAGES_PANEL_BACKGROUND_COLOR = SELF_PANEL_BACKGROUND_COLOR;
export const PRIVATE_MESSAGES_PANEL_BORDER_COLOR = SELF_PANEL_BORDER_COLOR;
export const PRIVATE_MESSAGES_PANEL_LIST_BACKGROUND_COLOR = SELF_PANEL_CONTENT_BACKGROUND_COLOR;
export const PRIVATE_MESSAGES_PANEL_LIST_ITEM_HOVER_COLOR = color(PRIVATE_MESSAGES_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'), 0.25)
    .string();
export const PRIVATE_MESSAGES_PANEL_ACTIVE_USER_BACKGROUND_COLOR = color(PRIVATE_MESSAGES_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'))
    .string();
export const PRIVATE_MESSAGES_PANEL_MESSAGES_BACKGROUND_COLOR = color(PRIVATE_MESSAGES_PANEL_BACKGROUND_COLOR)
    .darken(0.25)
    .string();
export const THEM_PRIVATE_MESSAGE_BACKGROUND_COLOR = color(PRIVATE_MESSAGES_PANEL_ACTIVE_USER_BACKGROUND_COLOR)
    .mix(color('white'))
    .string();
export const ME_PRIVATE_MESSAGE_BACKGROUND_COLOR = LIGHT_BLUE_COLOR;
export const PRIVATE_MESSAGES_CONVERSATION_DIVIDER_COLOR = PRIVATE_MESSAGES_PANEL_BACKGROUND_COLOR;
export const ENTRY_PANEL_BACKGROUND_COLOR = CHAT_PANEL_MESSAGES_BACKGROUND_COLOR;
export const ENTRY_PANEL_BORDER_COLOR = CHAT_PANEL_BACKGROUND_COLOR;
export const DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.2).string();
export const DEFAULT_BACKGROUND_HIGHLIGHT_COLOR = color(DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR)
    .mix(color('white'), 0.25)
    .string();
export const TOURNEY_HEADER_TEXT_COLOR = LIGHT_YELLOW_COLOR;
export const TOURNEY_HEADER_EMPHASIS_TEXT_COLOR = color(RED_COLOR).mix(color(TOURNEY_HEADER_TEXT_COLOR)).hex();
export const LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR = YELLOW_COLOR;
export const LOBBY_NEXT_TOURNEY_DISPLAY_TEXT_COLOR = color(LOBBY_NEXT_TOURNEY_DISPLAY_BORDER_COLOR)
    .mix(color('white'))
    .hex();
export const POT_LABEL_COLOR_NUM = 0xbbbbbb;
export const JACKS_COLOR = YELLOW_COLOR;
export const JACKS_POT_COLOR_NUM = color(YELLOW_COLOR).lighten(0.3).saturate(1.5).rgbNumber();
export const JACKS_POT_SUBTLE_COLOR_NUM = color(JACKS_POT_COLOR_NUM).mix(color('#777777'), 0.7).rgbNumber();
export const LOBBY_ROOM_GENERIC_COLOR = color(SLIGHT_GREENISH_GRAY_COLOR).mix(color('white'), 0.25).hex();
export const LOBBY_ROOM_GENERIC_HOVER_COLOR = color(LOBBY_ROOM_GENERIC_COLOR).lighten(0.2).hex();
export const LOBBY_ROOM_GENERIC_DIMMED_COLOR = color(LOBBY_ROOM_GENERIC_COLOR).darken(0.3).hex();
export const LOBBY_ROOM_GENERIC_DIMMED_HOVER_COLOR = color(LOBBY_ROOM_GENERIC_DIMMED_COLOR).lighten(0.1).hex();
export const LOBBY_AUTO_MTT_COLOR = ROOM_INFO_PANEL_BORDER_COLOR;
export const LOBBY_AUTO_MTT_HOVER_COLOR = color(LOBBY_AUTO_MTT_COLOR).lighten(0.15).hex();
export const LOBBY_AUTO_MTT_DIMMED_COLOR = color(LOBBY_AUTO_MTT_COLOR).desaturate(0.85).hue(0.1).darken(0.35).hex();
export const LOBBY_AUTO_MTT_DIMMED_HOVER_COLOR = color(LOBBY_AUTO_MTT_DIMMED_COLOR).lighten(0.1).hex();
export const HISTORY_PANEL_BACKGROUND_COLOR = ROOM_INFO_PANEL_BACKGROUND_COLOR;
export const HISTORY_PANEL_BORDER_COLOR = ROOM_INFO_PANEL_BORDER_COLOR;
export const HISTORY_PANEL_LIST_BACKGROUND_COLOR = ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR;
export const HISTORY_PANEL_SUB_HEADER_BACKGROUND_COLOR = color(ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'), 0.35)
    .hex();
export const HISTORY_PANEL_HEADER_BACKGROUND_COLOR = color(ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'), 0.75)
    .hex();
export const HISTORY_PANEL_HAND_SEPARATOR_COLOR = HISTORY_PANEL_BACKGROUND_COLOR;
export const DEBUG_PANEL_BACKGROUND_COLOR = PURPLE_COLOR;
export const DEBUG_PANEL_BORDER_COLOR = color(DEBUG_PANEL_BACKGROUND_COLOR).lighten(0.5).hex();
export const DEBUG_PANEL_LIST_BACKGROUND_COLOR = color(DEBUG_PANEL_BACKGROUND_COLOR).darken(0.5).hex();
export const SIDE_BETS_PANEL_BACKGROUND_COLOR = DEBUG_PANEL_BACKGROUND_COLOR;
export const SIDE_BETS_PANEL_BORDER_COLOR = DEBUG_PANEL_BORDER_COLOR;
export const SIDE_BETS_PANEL_LIST_BACKGROUND_COLOR = DEBUG_PANEL_LIST_BACKGROUND_COLOR;
export const SIDE_BETS_PANEL_HOVER_COLOR = color(SIDE_BETS_PANEL_BACKGROUND_COLOR)
    .mix(color(SIDE_BETS_PANEL_LIST_BACKGROUND_COLOR))
    .hex();
export const BOMBS_PANEL_BACKGROUND_COLOR = '#224466';
export const BOMBS_PANEL_BORDER_COLOR = color(BOMBS_PANEL_BACKGROUND_COLOR).lighten(0.5).hex();
export const BOMBS_PANEL_LIST_BACKGROUND_COLOR = color(BOMBS_PANEL_BACKGROUND_COLOR).darken(0.5).hex();
export const DRAGGABLE_BOMB_BUTTON_BACKGROUND_COLOR = BOMBS_PANEL_BACKGROUND_COLOR;
export const DRAGGABLE_BOMB_BUTTON_HOVER_COLOR = color(DRAGGABLE_BOMB_BUTTON_BACKGROUND_COLOR).lighten(0.15).hex();
export const DRAGGABLE_BOMB_BUTTON_ACTIVE_COLOR = color(DRAGGABLE_BOMB_BUTTON_BACKGROUND_COLOR).lighten(0.3).hex();
export const CHAT_PANEL_CARD_BACKGROUND_COLOR = color(ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR)
    .mix(color('white'), 0.75)
    .hex();
export const MODAL_HEADER_BACKGROUND_COLOR = color(DEFAULT_BACKGROUND_COLOR).lighten(0.35).hex();
export const MODAL_HEADER_BORDER_COLOR = color(MODAL_HEADER_BACKGROUND_COLOR).lighten(0.35).hex();
export const SUBTLE_MODAL_TEXT_COLOR = color(DEFAULT_BACKGROUND_COLOR).mix(color('white')).hex();
export const PLAYER_BUBBLE_CARD_BACKGROUND_COLOR_NUM = color(CHAT_PANEL_BACKGROUND_COLOR)
    .mix(color('white'), 0.3)
    .rgbNumber();
export const PLAYER_BUBBLE_TEXT_COLOR_NUM = color(CHAT_PANEL_BACKGROUND_COLOR).mix(color('white'), 0.75).rgbNumber();
export const PLAYER_BUBBLE_CARD_BORDER_COLOR_NUM = PLAYER_BUBBLE_TEXT_COLOR_NUM;
// replace some red text color in message boxes with something higher contrast:
export const MESSAGE_BOX_RED_FONT_REPLACEMENT_COLOR = YELLOW_COLOR;
export const HEADER_SUBTITLE_COLOR = PLAYER_INFO_PANEL_HEADER_COLOR;
export const PROGRESS_BAR_COLOR = ENTRY_PANEL_BORDER_COLOR;
export const PROGRESS_BAR_BACKGROUND_COLOR = DARKEST_GREENISH_BLUE;
export const DISCARD_CONTROLS_ARROW_COLOR_NUM = color(ROOM_INFO_PANEL_BACKGROUND_COLOR).rgbNumber();
export const DISCARD_CONTROLS_ARROW_LINE_COLOR_NUM = color(ROOM_INFO_PANEL_BORDER_COLOR).rgbNumber();
export const HEADER_BACKGROUND_COLOR = '#222';
export const ROOM_NAME_HYPERLINK_COLOR = PURPLE_COLOR;
// same as background (theme) color in manifest.json:
export const TRANSITION_ANIMATION_BACKGROUND_COLOR = '#436580';
export const ENTRY_SIDE_PANEL_TITLE_COLOR = TURQUOISE_COLOR;
export const RIGHT_PANEL_ACTIVE_BUTTON_BACKGROUND_COLOR = color(HEADER_BACKGROUND_COLOR).mix(color('white'), 0.2).hex();
export const RIGHT_PANEL_TOURNEY_ROOM_ACTIVE_BUTTON_BACKGROUND_COLOR = color(TOURNEY_HEADER_BACKGROUND_COLOR)
    .mix(color('white'), 0.2)
    .hex();
export const RIGHT_PANEL_BUTTON_HOVER_COLOR = color(HEADER_BACKGROUND_COLOR).mix(color('white'), 0.1).hex();
export const RIGHT_PANEL_TOURNEY_ROOM_BUTTON_HOVER_COLOR = color(TOURNEY_HEADER_BACKGROUND_COLOR)
    .mix(color('white'), 0.1)
    .hex();
export const DRAWER_ACCOUNT_ICON_COLOR = LIGHT_BLUE_COLOR;
export const DRAWER_GAME_INFO_ICON_COLOR = '#CCCCCC';
export const DRAWER_BAD_BEAT_JACKPOT_ICON_COLOR = YELLOW_COLOR;
export const DRAWER_TOURNEYS_ICON_COLOR = LIGHT_YELLOW_COLOR;
export const DRAWER_RANKINGS_ICON_COLOR = color(TURQUOISE_COLOR).lighten(0.3).hex();
export const DRAWER_PLAYERS_ICON_COLOR = color(LIGHT_PURPLE_COLOR).lighten(0.3).saturate(1.2).hex();
export const SIDE_BETS_ACCENT_COLOR = '#a5ffff';
export const SIDE_BETS_ACCENT_COLOR_NUM = color(SIDE_BETS_ACCENT_COLOR).rgbNumber();
export const SIDE_BET_BUTTON_SUB_LABEL_COLOR = color(SIDE_BETS_ACCENT_COLOR).darken(0.3).desaturate(0.5).hex();
export const SIDE_BET_BUTTON_SUB_LABEL_COLOR_NUM = color(SIDE_BET_BUTTON_SUB_LABEL_COLOR).rgbNumber();
export const SIDE_BET_BUTTON_BACKGROUND_COLOR = color(SIDE_BETS_ACCENT_COLOR).darken(0.8).desaturate(0.5).hex();
export const SIDE_BET_BUTTON_BACKGROUND_COLOR_NUM = color(SIDE_BET_BUTTON_BACKGROUND_COLOR).rgbNumber();
export const SIDE_BET_BUTTON_HOVER_COLOR = color(SIDE_BETS_ACCENT_COLOR).darken(0.7).desaturate(0.5).hex();
export const SIDE_BET_BUTTON_HOVER_COLOR_NUM = color(SIDE_BET_BUTTON_HOVER_COLOR).rgbNumber();
export const SIDE_BET_WON_DOT_COLOR_NUM = color(GREEN_COLOR).lighten(0.2).rgbNumber();
export const SIDE_BET_LOST_DOT_COLOR_NUM = color(RED_COLOR).lighten(0.3).rgbNumber();
export const SIDE_BET_PENDING_DOT_COLOR_NUM = SIDE_BETS_ACCENT_COLOR_NUM;
export const SIDE_BET_INCOMPLETE_DOT_COLOR_NUM = color(DARK_GREENISH_BLUE).lighten(0.5).desaturate(1).rgbNumber();
export const SIDE_BETS_PANEL_TEXT_VALUE_COLOR = '#AAA';
/**
 * Colors to differentiate between different game instances in console logs.
 */
export const INSTANCE_LOG_COLORS = [
    chroma(70, 0.8, 0.6, 'hsl').hex(),
    chroma(140, 0.8, 0.6, 'hsl').hex(),
    chroma(210, 0.8, 0.6, 'hsl').hex(),
    chroma(280, 0.8, 0.6, 'hsl').hex()
];
